import styled from 'styled-components';

import { CloseIcon } from '@images/svg';
import colors from '@theme/colors';

export default {
  Root: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    z-index: 999;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    padding: 5%;
    transition: 0.6s cubic-bezier(0.55, 0.1, 0.35, 1);

    iframe {
      width: 100%;
      height: 51vw;
      max-height: 75vh;
    }

    &.enter {
      transform: translateY(100%);
    }
    &.enter-active {
      transform: translateY(0%);
    }

    &.exit-active {
      transform: translateY(100%);
    }
  `,

  IconWrap: styled(CloseIcon)`
    color: ${colors.charcoal};
    background-color: ${colors.white};
    cursor: pointer;
    position: absolute;
    top: 5%;
    right: 5%;
    padding: 12px;
    border-radius: 24px;
    box-sizing: content-box;
    transition: 0.15s ease-in-out;
    z-index: 9999;
    &:hover {
      color: ${colors.white};
      background-color: ${colors.charcoal};
    }
  `,

  Video: styled.iframe`
    flex-shrink: 0;
    margin: auto;
    border: 0;
  `,
};
